module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-btn",
    class: [{
      'weui-btn_disabled': _vm.disabled
    }, ("weui-btn_" + _vm.btnType)],
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01950d88","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/public-lib/vue-components/src/components/c-button/index.vue
// module id = 345
// module chunks = 0